const state = {
  returnMgmtList: JSON.parse(sessionStorage.getItem('returnMgmtList')) || []
}

const mutations = {
  setReturnMgmtList(state, data) {
    sessionStorage.setItem('returnMgmtList', JSON.stringify(data));
    state.returnMgmtList = data;
  }
}

const getters = {
  getReturnInfoById(state){
        return (id) => {
            return state.returnMgmtList.find((item) => {
                return item.id == id
            });
        }
    }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
};
